/** @format */

import React, { useEffect, useState } from "react";
import {
  fetchAllClients,
  addClientWithInitialMonth,
  addMonthToClient,
} from "../api-helper/damapi";

import "../Style/clientManager.css";

function ClientManager() {
  const [clients, setClients] = useState([]);
  const [newClient, setNewClient] = useState({
    name: "",
    email: "",
    password: "",
  });
  const [newSetting, setNewSetting] = useState({
    month: "",
    strike: "",
    premium: "",
    quantity: "",
    penaltyPercentage: "",
  });
  const [selectedEmail, setSelectedEmail] = useState("");
  const [expandedClient, setExpandedClient] = useState(null);
  const [editedSettings, setEditedSettings] = useState({});
  const [message, setMessage] = useState("");

  const [adminAuthenticated, setAdminAuthenticated] = useState(
    localStorage.getItem("adminAuthenticated") === "true"
  );
  const [adminPassword, setAdminPassword] = useState("");
  const [adminError, setAdminError] = useState("");

  useEffect(() => {
    if (adminAuthenticated) {
      loadClients();
    }
  }, [adminAuthenticated]);

  useEffect(() => {
    if (expandedClient) {
      const targetClient = clients.find((c) => c.email === expandedClient);
      if (targetClient) {
        const obj = {};
        targetClient.settings.forEach((s) => {
          obj[s.month] = {
            strike: s.strike,
            premium: s.premium,
            quantity: s.quantity,
            penaltyPercentage: s.penaltyPercentage,
          };
        });
        setEditedSettings(obj);
      }
    }
  }, [expandedClient, clients]);

  const loadClients = async () => {
    const data = await fetchAllClients();
    setClients(data);
  };

  const handleAddClient = async () => {
    await addClientWithInitialMonth({ ...newClient, ...newSetting });
    setNewClient({ name: "", email: "", password: "" });
    setNewSetting({
      month: "",
      strike: "",
      premium: "",
      quantity: "",
      penaltyPercentage: "",
    });
    loadClients();
  };

  const handleEditMonth = async (clientEmail, updatedMonth) => {
    const { month, strike, premium, quantity, penaltyPercentage } =
      updatedMonth;
    await addMonthToClient({
      email: clientEmail,
      month,
      strike,
      premium,
      quantity,
      penaltyPercentage,
    });
    setMessage("Changes saved successfully.");
    setTimeout(() => setMessage(""), 3000);
    loadClients();
  };

  const handleAddMonth = async () => {
    await addMonthToClient({ email: selectedEmail, ...newSetting });
    setNewSetting({ month: "", strike: "", premium: "", quantity: "" });
    loadClients();
  };

  const generateMonthOptions = (yearsBefore = 1, yearsAfter = 1) => {
    const months = [];
    const today = new Date();
    const startYear = today.getFullYear() - yearsBefore;
    const endYear = today.getFullYear() + yearsAfter;

    for (let year = startYear; year <= endYear; year++) {
      for (let month = 0; month < 12; month++) {
        const formattedMonth = `${year}-${String(month + 1).padStart(2, "0")}`;
        months.push(formattedMonth);
      }
    }
    return months.reverse();
  };

  const monthOptions = generateMonthOptions();
  if (!adminAuthenticated) {
    return (
      <div className='admin-access'>
        <h2>Admin Access</h2>
        <input
          type='password'
          placeholder='Enter admin password'
          value={adminPassword}
          onChange={(e) => setAdminPassword(e.target.value)}
        />
        <button
          onClick={() => {
            if (adminPassword === "passwordsecure25") {
              setAdminAuthenticated(true);
              localStorage.setItem("adminAuthenticated", "true");

              setAdminError("");
            } else {
              setAdminError("Incorrect password.");
            }
          }}
        >
          Enter
        </button>
        {adminError && <p className='error-message'>{adminError}</p>}
      </div>
    );
  }

  return (
    <div className='client-container2'>
      <h2>Client Management</h2>
      <div className='client-table-wrapper2'>
        <table className='client-table2'>
          <thead>
            <tr>
              <th>Name</th>
              <th>Email</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {clients.map((client) => (
              <React.Fragment key={client.email}>
                <tr className='client-row2'>
                  <td>{client.name}</td>
                  <td>{client.email}</td>
                  <td>
                    <button
                      onClick={() =>
                        setExpandedClient(
                          expandedClient === client.email ? null : client.email
                        )
                      }
                    >
                      {expandedClient === client.email ? "Hide" : "View"}
                    </button>
                  </td>
                </tr>

                {expandedClient === client.email && (
                  <tr className='month-row2'>
                    <td colSpan='3'>
                      <table className='month-table2'>
                        <thead>
                          <tr>
                            <th>Month</th>
                            <th>Strike</th>
                            <th>Premium</th>
                            <th>Quantity</th>
                            <th>Penalty %</th>
                            <th>Edit</th>
                          </tr>
                        </thead>
                        <tbody>
                          {client.settings.map((s, i) => (
                            <tr key={i}>
                              <td>{s.month}</td>
                              <td>
                                <input
                                  value={editedSettings[s.month]?.strike || ""}
                                  onChange={(e) =>
                                    setEditedSettings({
                                      ...editedSettings,
                                      [s.month]: {
                                        ...editedSettings[s.month],
                                        strike: e.target.value,
                                      },
                                    })
                                  }
                                />
                              </td>
                              <td>
                                <input
                                  value={editedSettings[s.month]?.premium || ""}
                                  onChange={(e) =>
                                    setEditedSettings({
                                      ...editedSettings,
                                      [s.month]: {
                                        ...editedSettings[s.month],
                                        premium: e.target.value,
                                      },
                                    })
                                  }
                                />
                              </td>
                              <td>
                                <input
                                  value={
                                    editedSettings[s.month]?.quantity || ""
                                  }
                                  onChange={(e) =>
                                    setEditedSettings({
                                      ...editedSettings,
                                      [s.month]: {
                                        ...editedSettings[s.month],
                                        quantity: e.target.value,
                                      },
                                    })
                                  }
                                />
                              </td>
                              <td>
                                <input
                                  value={
                                    editedSettings[s.month]
                                      ?.penaltyPercentage || ""
                                  }
                                  onChange={(e) =>
                                    setEditedSettings({
                                      ...editedSettings,
                                      [s.month]: {
                                        ...editedSettings[s.month],
                                        penaltyPercentage: e.target.value,
                                      },
                                    })
                                  }
                                />
                              </td>
                              <td>
                                <button
                                  onClick={() =>
                                    handleEditMonth(client.email, {
                                      month: s.month,
                                      ...editedSettings[s.month],
                                    })
                                  }
                                >
                                  Edit
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </td>
                  </tr>
                )}
              </React.Fragment>
            ))}
          </tbody>
        </table>
        {message && <div className='success-message2'>{message}</div>}
      </div>

      <div className='form-section2'>
        <h3>Add New Client</h3>
        <input
          placeholder='Name'
          value={newClient.name}
          onChange={(e) => setNewClient({ ...newClient, name: e.target.value })}
        />
        <input
          placeholder='Email'
          value={newClient.email}
          onChange={(e) =>
            setNewClient({ ...newClient, email: e.target.value })
          }
        />
        <input
          placeholder='Password'
          type='password'
          value={newClient.password}
          onChange={(e) =>
            setNewClient({ ...newClient, password: e.target.value })
          }
        />
        <input
          type='month'
          value={newSetting.month}
          onChange={(e) =>
            setNewSetting({ ...newSetting, month: e.target.value })
          }
          className='custom-input'
        />
        <input
          placeholder='Strike Price'
          value={newSetting.strike}
          onChange={(e) =>
            setNewSetting({ ...newSetting, strike: e.target.value })
          }
        />
        <input
          placeholder='Premium Fee'
          value={newSetting.premium}
          onChange={(e) =>
            setNewSetting({ ...newSetting, premium: e.target.value })
          }
        />
        <input
          placeholder='Baseload Quantity'
          value={newSetting.quantity}
          onChange={(e) =>
            setNewSetting({ ...newSetting, quantity: e.target.value })
          }
        />
        <input
          placeholder='Penalty % '
          value={newSetting.penaltyPercentage}
          onChange={(e) =>
            setNewSetting({ ...newSetting, penaltyPercentage: e.target.value })
          }
        />

        <button onClick={handleAddClient}>Add Client</button>
      </div>

      <div className='form-section2'>
        <h3>Add Month to Existing Client</h3>
        <select
          onChange={(e) => setSelectedEmail(e.target.value)}
          value={selectedEmail}
        >
          <option value=''>-- Select Client --</option>
          {clients.map((c) => (
            <option key={c.email} value={c.email}>
              {c.name} ({c.email})
            </option>
          ))}
        </select>
        <input
          type='month'
          value={newSetting.month}
          onChange={(e) =>
            setNewSetting({ ...newSetting, month: e.target.value })
          }
          className='custom-input'
        />
        <input
          placeholder='Strike Price'
          value={newSetting.strike}
          onChange={(e) =>
            setNewSetting({ ...newSetting, strike: e.target.value })
          }
        />
        <input
          placeholder='Premium Fee'
          value={newSetting.premium}
          onChange={(e) =>
            setNewSetting({ ...newSetting, premium: e.target.value })
          }
        />
        <input
          placeholder='Baseload Quantity'
          value={newSetting.quantity}
          onChange={(e) =>
            setNewSetting({ ...newSetting, quantity: e.target.value })
          }
        />
        <input
          placeholder='Penalty % '
          value={newSetting.penaltyPercentage}
          onChange={(e) =>
            setNewSetting({ ...newSetting, penaltyPercentage: e.target.value })
          }
        />

        <button onClick={handleAddMonth}>Add Month</button>
      </div>
    </div>
  );
}

export default ClientManager;
